import { marked } from "marked";
import DOMPurify from "dompurify";

/**
 * Converts markdown/HTML to safe sanitized HTML string.
 * Supports both raw markdown syntax (headers, lists, bold, italics, links)
 * and rich-text HTML (p, br, strong, etc.), stripping any unsafe script or attributes.
 */
export function renderMarkdownAndSanitize(content?: string | null): string {
  if (!content) return "";
  const trimmed = content.trim();
  if (
    !trimmed ||
    trimmed === "<p></p>" ||
    trimmed === "<p><br></p>" ||
    trimmed === "<p>&nbsp;</p>"
  ) {
    return "";
  }

  try {
    // Parse markdown into HTML. If already HTML, marked safely preserves tags.
    const rawHtml = marked.parse(trimmed, {
      async: false,
      breaks: true,
      gfm: true,
    }) as string;

    // Sanitize with DOMPurify
    if (typeof window !== "undefined") {
      return DOMPurify.sanitize(rawHtml, {
        ALLOWED_TAGS: [
          "p",
          "br",
          "strong",
          "b",
          "em",
          "i",
          "u",
          "s",
          "strike",
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "ul",
          "ol",
          "li",
          "a",
          "blockquote",
          "code",
          "pre",
          "hr",
          "span",
          "div",
        ],
        ALLOWED_ATTR: ["href", "target", "rel", "class"],
      });
    }

    return rawHtml;
  } catch {
    // Fallback if parser fails
    return content;
  }
}
